import React, { useEffect } from "react";
import CalendarM from "react-calendar";
import { useDispatch } from "react-redux";
import "react-calendar/dist/Calendar.css";
import styles from "./Calendar.module.scss";
import "./CalendarOverride.scss";

import { dateToString } from "../../utils/util";

import { fetchEvents } from "../../store/slices/events/asyncThunks";

const Calendar = (props) => {
  const dispatch = useDispatch();

  const getMonday = (d) => {
    d = new Date(d);
    var day = d.getDay(),
      diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    // return new Date(d.setDate(diff - 7));
    return new Date(d.setDate(diff));
  };

  const getFridayOfCurrentWeek = () => {
    const today = new Date();
    const first = today.getDate() - today.getDay() + 1;
    const fifth = first + 4;

    const friday = new Date(today.setDate(fifth));

    return friday;
  };

  const handleSelectRange = (dates) => {
    let dateFrom = new Date(dates[0]);
    dateFrom.setDate(dateFrom.getDate() + 1);

    let dateTo = new Date(dates[1]);
    dateTo.setDate(dateTo.getDate() + 1);
    dispatch(
      fetchEvents({ from: dateToString(dateFrom), to: dateToString(dateTo) })
    );
  };

  useEffect(() => {
    handleSelectRange([getMonday(new Date()), getFridayOfCurrentWeek()]);
  }, []);

  return (
    <div className={styles.cardContainerCalendar}>
      <CalendarM
        defaultView="month"
        minDetail={"month"}
        showNeighboringMonth={false}
        next2Label={null}
        prev2Label={null}
        selectRange={true}
        returnValue={"range"}
        onChange={(dates) => handleSelectRange(dates)}
        className={styles.reactCalendar}
        defaultValue={[getMonday(new Date()), getFridayOfCurrentWeek()]}
      ></CalendarM>
    </div>
  );
};

export default Calendar;
